__webpack_require__.p = "https://mantrafootball.org/entry/";